import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { TableOfContentsComponent } from './table-of-contents.component';
import { TocSubmenuComponent } from './toc-submenu.component';

@NgModule({
  imports: [CommonModule, BsDropdownModule],
  declarations: [TableOfContentsComponent, TocSubmenuComponent],
  exports: [TableOfContentsComponent, TocSubmenuComponent],
})
export class TableOfContentsModule {}
